import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RichiesteDgpeService {

  constructor(private http: HttpClient, private datePipe: DatePipe) { }

  public getOcdpc(page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.RichiestaDgpeFilterDTO) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        if (key == "dataInizioDa" || key == "dataInizioA" || key == "dataFineDa" || key == "dataFineA") {
          filters[key] = this.datePipe.transform(filters[key], "yyyy/MM/dd");
        }
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.RichiestaDgpeDTO[]>(`${environment.urls.base}/richieste/list`,
        {
          params: searchParams
        });
  }

  public getRichiestaById(idRichiesta: number) {
    return this.http
      .get<ModelEventiCalamitosi.RichiestaDgpeDTO>(`${environment.urls.base}/richieste/id_richiesta/${idRichiesta}`,);
  }

  public upserRichiesta(richiestaDgpeDTO: ModelEventiCalamitosi.RichiestaDgpeDTO) {
    return this.http
      .post<ModelEventiCalamitosi.RichiestaDgpeDTO>(
        `${environment.urls.base}/richieste/upsert`,
        richiestaDgpeDTO,
        {
          observe: 'response'
        }
      );
  }

  delete(idRichiesta: number) {
    return this.http.delete(`${environment.urls.base}/richieste/delete/${idRichiesta}`);
  }

  aggiungiDpgr(ocdpc: string, controlList: ModelEventiCalamitosi.EventoDto[], aggiungiTutti: string, eventiSearchableDto: ModelEventiCalamitosi.EventiSearchableDto) {

    if (eventiSearchableDto.dataEvento != undefined && eventiSearchableDto.dataEvento != null && eventiSearchableDto.dataEvento != "") {
      if(eventiSearchableDto.dataEvento.includes("/")){
        let data: string[] = eventiSearchableDto.dataEvento.split('/');
        eventiSearchableDto.dataEvento = '';
        data.reverse();
       for (let index = 0; index < data.length; index++) {
         let next = index;
         const element = data[index];
         eventiSearchableDto.dataEvento += data[index];
        if((next + 1) < data.length )  eventiSearchableDto.dataEvento += "-";
        }
      }
    }

    let richiestaDgpeListDTO: ModelEventiCalamitosi.RichiestaDpgeListDTO = {
      controlList: controlList,
      ocdpc: ocdpc,
      aggiungiTutti: aggiungiTutti,
      filtro: eventiSearchableDto
    }
    return this.http.post<number>(
      `${environment.urls.base}/richieste/aggiungi-dpgr`,
      richiestaDgpeListDTO,
      {
        observe: 'response'
      });
  }

}
